export enum SETTING_ID {
  SHOP_NAME = 'name',
  SHOP_LOGO='shop_logo',
  RECEIPT_LOGO='receipt_logo',
  RECEIPT_IMAGE='receipt_image',
  PRINT_PREVIEW_IMAGE='print_preview_image',
  SERVICE_CHARGE = 'service_charge',
  ROUNDING = 'rounding',
  SHOW_EXPENSE = 'show_expense',

  ROUNDING_OPTION_NONE = 'none',
  ROUNDING_OPTION_NEAREST = 'nearest',
  ROUNDING_OPTION_UP = 'up',
  ROUNDING_OPTION_DOWN = 'down',

  TAX_MODE = 'tax_mode',
  TAX_VALUE = 'tax_value',

  DISCOUNT_BILL = 'discount_bill',
  PAYMENT = 'payment',
  ROOMS = 'rooms',
  QR_PROMTPAY = 'qr_promtpay',

  TABLES = 'tables',

  REPORT_SUMMARY = 'report_summary',
  REPORT_ITEMS = 'report_items',
  REPORT_VOIDED = 'report_voided',
  REPORT_OPENMENU = 'report_openmenu',

  PRINTER_RECEIPT_ID_RANDOM = 'printer_receipt_id_random',
  PRINTER_RECEIPT = 'printer_receipt',
  PRINTER_RECEIPT_COPY = 'printer_receipt_copy',
  PRINTER_RECEIPT_COMMENTS = 'printer_receipt_comments',
  PRINTER_JOB_MOVE_TABLE = 'printer_job_move_table',
  PRINTER_JOB_VOID_ITEMS =   'printer_job_void_items',
  PRINTER_JOB_SHOW_PRICE = 'printer_job_show_price',
  PRINTER_JOB_SKIP_PRICE_ZERO = 'printer_job_skip_price_zero',
  PRINTER_SHOW_TIMEIN_TIMEOUT = 'printer_show_timein_timeout',
  PRINTER_SHOW_NUMBER_OF_CUSTOMER = 'printer_show_number_of_customer',
  PRINTER_SHOW_SERVICE_CHARGE_PERCENT = 'printer_show_service_charge_percent',
  SHOW_BEFORE_VAT = 'show_before_vat',

  //โหมดยอดเงินที่ใช้พิมพ์ในรายงานยอดขายสินค้า (Products Summary)
  REPORT_PRODUCT_SUMMARY_AMOUNT_MODE = 'report_product_summary_amount_mode',

  PRINTER_PREVIEW_HEADER = 'printer_preview_header',
  PRINTER_PREVIEW_FOOTER = 'printer_preview_footer',

  PRINTER_RECEIPT_HEADER = 'printer_receipt_header',
  PRINTER_RECEIPT_FOOTER = 'printer_receipt_footer',

  PRINTER_0_MODE = 'printer_0_mode',
  PRINTER_1_MODE = 'printer_1_mode',
  PRINTER_2_MODE = 'printer_2_mode',
  PRINTER_3_MODE = 'printer_3_mode',
  PRINTER_4_MODE = 'printer_4_mode',
  PRINTER_5_MODE = 'printer_5_mode',

  PRINTER_RECEIPT_FONT_SIZE = 'printer_receipt_font_size',
  PRINTER_JOB_KITCHEN_FONT_SIZE = 'printer_job_kitchen_font_size',


  QRCODE_MENU_1 =  'qrcode_menu_1',
  QRCODE_MENU_2 =  'qrcode_menu_2',
  QRCODE_MENU_3 =  'qrcode_menu_3',
  QRCODE_MENU_4 =  'qrcode_menu_4',
  QRCODE_MENU_5 =  'qrcode_menu_5',

  OPEN_MENU_MODE = 'open_menu_mode',
  OPEN_MENU_TYPE = 'open_menu_type',
  OPEN_MENU_ID = 'open_menu_group',

  
  
  EMAIL_REPORTS = "email_reports",

  CASHIER_2ND = 'cashier_2nd',
  MOBILE_DEVICES_LIMIT='mobile_devices_limit',

  POS_UI_MODE = 'pos_ui_mode', //key
  POS_UI_MODE_EASY = 'easy',  //value
  POS_UI_MODE_ADVANCE = 'advance' //value
}
